import React, { useMemo } from 'react';

import { customTheme } from 'theme';

import { formatBytes } from 'components/DataDisplay';
import { BarChart } from 'components/Visualization';
import { DashboardWidget } from 'components/Visualization/CDashboard/Widget/DashboardWidget';
import {
  customizedXAxisTick,
  customizedYAxisTick,
  rotatedXAxisTick,
  sortedLineChartTooltip,
} from 'components/Visualization/Charts/utils';

import { CloudEventsSummaryChartProps } from '../../../types';

import {
  formatCloudEventsSummaryTime,
  getCloudEventsSummaryXAxisInterval,
} from './utils';

const DATA_ACCESSED = 'Data Accessed';

const byteYAxisTick = (props: any) =>
  customizedYAxisTick({
    ...props,
    payload: {
      ...props.payload,
      value: formatBytes(props.payload.value),
    },
  });

export const DataAccessed = ({
  summary,
  isHourly,
  summaryPeriod,
}: CloudEventsSummaryChartProps) => {
  const chartData = useMemo(
    () =>
      summary.data?.data_accessed?.map(point => ({
        Date: formatCloudEventsSummaryTime(point),
        [DATA_ACCESSED]: Number(point.data_accessed_bytes ?? 0),
      })) ?? [],
    [summary.data?.data_accessed],
  );

  return (
    <DashboardWidget
      label="Data Accessed"
      subHeader={isHourly ? undefined : summaryPeriod ?? 'Last 7 days'}
      isLoading={summary.isLoading}
      noData={!chartData.length}
      paddingX={0}
      paddingBottom={0}
      content={
        <BarChart
          data={chartData}
          xField="Date"
          yField={[DATA_ACCESSED]}
          legend={false}
          customTooltipContent={sortedLineChartTooltip}
          colorMap={{
            [DATA_ACCESSED]: customTheme.colors.blue['100'],
          }}
          styles={{
            barChart: {
              margin: { bottom: 5, left: 0 },
              style: { overflow: 'visible' },
            },
            bar: {
              barSize: 15,
            },
            xAxis: {
              axisLine: true,
              tickLine: true,
              tick: isHourly ? customizedXAxisTick : rotatedXAxisTick,
              height: isHourly ? 30 : 55,
              interval: getCloudEventsSummaryXAxisInterval(
                isHourly,
                chartData.length,
              ),
            },
            yAxis: {
              axisLine: false,
              tickLine: false,
              tick: byteYAxisTick,
              width: 80,
            },
          }}
        />
      }
    />
  );
};
